// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UseLongClick = require("../ui-utils/UseLongClick.bs.js");
var MM_wrk_client = require("../worker/MM_wrk_client.bs.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.bs.js");
var MM_cmp_test_regex = require("./MM_cmp_test_regex.bs.js");
var MM_wrk_FindParens = require("../worker/MM_wrk_FindParens.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var MM_cmp_type_settings = require("./MM_cmp_type_settings.bs.js");
var Divider = require("@mui/material/Divider").default;
var Expln_utils_jsonParse = require("../../rescript-utils/main/Expln_utils_jsonParse.bs.js");
var Checkbox = require("@mui/material/Checkbox").default;
var TextField = require("@mui/material/TextField").default;
var MM_cmp_web_src_settings = require("./MM_cmp_web_src_settings.bs.js");
var Sync = require("@mui/icons-material/Sync").default;
var IconButton = require("@mui/material/IconButton").default;
var MM_cmp_edit_stmts_setting = require("./MM_cmp_edit_stmts_setting.bs.js");
var MM_cmp_frag_transform_editor = require("./MM_cmp_frag_transform_editor.bs.js");
var FormControlLabel = require("@mui/material/FormControlLabel").default;
var MM_frag_transform_default_script = require("./MM_frag_transform_default_script.bs.js");

var allColors = [
  "#e6194B",
  "#3cb44b",
  "#ffe119",
  "#4363d8",
  "#f58231",
  "#911eb4",
  "#42d4f4",
  "#f032e6",
  "#bfef45",
  "#fabed4",
  "#469990",
  "#dcbeff",
  "#9A6324",
  "#fffac8",
  "#800000",
  "#aaffc3",
  "#808000",
  "#ffd8b1",
  "#000075",
  "#a9a9a9",
  "#000000"
];

var longClickDelayMsMin = (UseLongClick.repeatDelayMs | 0) + 100 | 0;

var setmm = {
  id: "0",
  alias: "set.mm:latest",
  url: "https://us.metamath.org/metamath/set.mm",
  trusted: false,
  err: undefined
};

var isetmm = {
  id: "0",
  alias: "iset.mm:latest",
  url: "https://us.metamath.org/metamath/iset.mm",
  trusted: false,
  err: undefined
};

var defaultAliases = [
  "set.mm:latest",
  "iset.mm:latest"
];

var defaultDiscColor = "#fabed4";

var defaultDeprColor = "#ffe119";

var defaultTranDeprColor = "#fffac8";

function createDefaultSettings(param) {
  return {
          parens: "( ) [ ] { } [. ]. [_ ]_ <. >. <\" \"> << >> [s ]s (. ). (( )) [b /b",
          parensErr: undefined,
          asrtsToSkip: [],
          descrRegexToDisc: "\\(New usage is discouraged\\.\\)",
          descrRegexToDiscErr: undefined,
          labelRegexToDisc: "",
          labelRegexToDiscErr: undefined,
          descrRegexToDepr: "",
          descrRegexToDeprErr: undefined,
          labelRegexToDepr: "",
          labelRegexToDeprErr: undefined,
          discColor: defaultDiscColor,
          deprColor: defaultDeprColor,
          tranDeprColor: defaultTranDeprColor,
          allowedFrms: {
            inSyntax: {
              useDisc: false,
              useDepr: true,
              useTranDepr: true
            },
            inEssen: {
              useDisc: false,
              useDepr: true,
              useTranDepr: true
            }
          },
          editStmtsByLeftClick: false,
          initStmtIsGoal: true,
          defaultStmtLabel: "qed",
          defaultStmtType: "|-",
          checkSyntax: true,
          stickGoalToBottom: true,
          autoMergeStmts: false,
          autoUnifyAll: true,
          typeNextId: 4,
          typeSettings: [
            {
              id: "0",
              typ: "wff",
              color: "#4363d8",
              prefix: "&W",
              err: undefined
            },
            {
              id: "1",
              typ: "term",
              color: "#000000",
              prefix: "&T",
              err: undefined
            },
            {
              id: "2",
              typ: "setvar",
              color: "#e6194B",
              prefix: "&S",
              err: undefined
            },
            {
              id: "3",
              typ: "class",
              color: "#f032e6",
              prefix: "&C",
              err: undefined
            }
          ],
          unifMetavarPrefix: "&",
          sortDisjByType: "class wff",
          webSrcNextId: 1,
          webSrcSettings: [
            setmm,
            isetmm
          ],
          longClickEnabled: true,
          longClickDelayMsStr: String(500),
          hideContextSelector: false,
          showVisByDefault: false,
          editorHistMaxLengthStr: String(20),
          useDefaultTransforms: true,
          useCustomTransforms: false,
          customTransforms: "",
          combCntMaxStr: String(10000)
        };
}

function addWebSrcSetting(st) {
  var newId = String(st.webSrcNextId);
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.webSrcSettings = st.webSrcSettings.concat([{
          id: newId,
          alias: "",
          url: "",
          trusted: false,
          err: undefined
        }]);
  newrecord.webSrcNextId = st.webSrcNextId + 1 | 0;
  return newrecord;
}

function validateAndCorrectParens(st) {
  var newParens = st.parens.trim();
  var parensErr = Common.getSpaceSeparatedValuesAsArray(newParens).length % 2 === 0 ? undefined : "Number of parentheses must be even.";
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.parensErr = parensErr;
  newrecord.parens = newParens;
  return newrecord;
}

function validateRegex(regex) {
  var msg = Common.strToRegex(regex);
  if (msg.TAG === /* Ok */0) {
    return ;
  } else {
    return msg._0;
  }
}

function validateColor(color) {
  if (allColors.includes(color)) {
    return color;
  } else {
    return Caml_array.get(allColors, 0);
  }
}

function validateAndCorrectDiscAndDeprSettings(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.labelRegexToDepr = st.labelRegexToDepr.trim();
  newrecord.descrRegexToDepr = st.descrRegexToDepr.trim();
  newrecord.labelRegexToDisc = st.labelRegexToDisc.trim();
  newrecord.descrRegexToDisc = st.descrRegexToDisc.trim();
  var newrecord$1 = Caml_obj.obj_dup(newrecord);
  newrecord$1.tranDeprColor = validateColor(newrecord.tranDeprColor);
  newrecord$1.deprColor = validateColor(newrecord.deprColor);
  newrecord$1.discColor = validateColor(newrecord.discColor);
  newrecord$1.labelRegexToDeprErr = validateRegex(newrecord.labelRegexToDepr);
  newrecord$1.descrRegexToDeprErr = validateRegex(newrecord.descrRegexToDepr);
  newrecord$1.labelRegexToDiscErr = validateRegex(newrecord.labelRegexToDisc);
  newrecord$1.descrRegexToDiscErr = validateRegex(newrecord.descrRegexToDisc);
  return newrecord$1;
}

function validateDefaultStmtLabel(label) {
  return label.replace(/[^A-Za-z0-9._-]/g, "");
}

function validateAndCorrectDefaultStmtType(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.defaultStmtType = st.defaultStmtType.trim();
  return newrecord;
}

function validateAndCorrectUnifMetavarPrefix(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.unifMetavarPrefix = st.unifMetavarPrefix.trim();
  return newrecord;
}

function validateAndCorrectDefaultStmtLabel(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.defaultStmtLabel = validateDefaultStmtLabel(st.defaultStmtLabel);
  return newrecord;
}

function validateAndCorrectTypeSettings(st) {
  var strContainsWhitespaceRegex = /\s+/;
  var validateAndCorrectTypeSetting = function (ts) {
    var newId = String(Belt_Option.getWithDefault(Belt_Int.fromString(ts.id), 0));
    var newTyp = ts.typ.trim();
    var typHasWhitespace = Belt_Option.isSome(Caml_option.null_to_opt(newTyp.match(strContainsWhitespaceRegex)));
    var typIsEmpty = newTyp.length === 0;
    var newColor = allColors.includes(ts.color) ? ts.color : Caml_array.get(allColors, 0);
    var newPrefix = ts.prefix.trim();
    var prefixHasWhitespace = Belt_Option.isSome(Caml_option.null_to_opt(newPrefix.match(strContainsWhitespaceRegex)));
    var prefixIsEmpty = newPrefix.length === 0;
    var err = typHasWhitespace ? "Type should not contain whitespaces." : (
        typIsEmpty ? "Type should not be empty." : (
            prefixHasWhitespace ? "Work variable prefix should not contain whitespaces." : (
                prefixIsEmpty ? "Work variable prefix should not be empty." : undefined
              )
          )
      );
    return {
            id: newId,
            typ: newTyp,
            color: newColor,
            prefix: newPrefix,
            err: err
          };
  };
  var validatedTypeSettings = st.typeSettings.map(validateAndCorrectTypeSetting);
  var distinctTypeIds = Belt_SetInt.fromArray(validatedTypeSettings.map(function (ts) {
            return Belt_Option.getExn(Belt_Int.fromString(ts.id));
          }));
  var validatedTypeSettings$1;
  if (Belt_SetInt.size(distinctTypeIds) === validatedTypeSettings.length) {
    validatedTypeSettings$1 = validatedTypeSettings;
  } else {
    var maxId = Belt_Option.getWithDefault(Belt_SetInt.maximum(distinctTypeIds), 0);
    validatedTypeSettings$1 = validatedTypeSettings.map(function (ts, i) {
          return {
                  id: String((maxId + i | 0) + 1 | 0),
                  typ: ts.typ,
                  color: ts.color,
                  prefix: ts.prefix,
                  err: ts.err
                };
        });
  }
  var maxTypSettId = validatedTypeSettings$1.reduce((function (maxId, ts) {
          var id = Belt_Option.getExn(Belt_Int.fromString(ts.id));
          if (id <= maxId) {
            return maxId;
          } else {
            return id;
          }
        }), 0);
  var newNextId = maxTypSettId < st.typeNextId ? st.typeNextId : maxTypSettId + 1 | 0;
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.typeSettings = validatedTypeSettings$1;
  newrecord.typeNextId = newNextId;
  return newrecord;
}

function validateAndCorrectWebSrcSettings(st) {
  var validateAndCorrectWebSrcSetting = function (src) {
    var newId = String(Belt_Option.getWithDefault(Belt_Int.fromString(src.id), 0));
    var newAlias = src.alias.trim();
    var newUrl = src.url.trim();
    var err = newUrl.length === 0 ? "URL should not be empty." : undefined;
    return {
            id: newId,
            alias: newAlias,
            url: newUrl,
            trusted: src.trusted,
            err: err
          };
  };
  var validatedWebSrcSettings = st.webSrcSettings.map(validateAndCorrectWebSrcSetting);
  var distinctIds = Belt_SetInt.fromArray(validatedWebSrcSettings.map(function (src) {
            return Belt_Option.getExn(Belt_Int.fromString(src.id));
          }));
  var validatedWebSrcSettings$1;
  if (Belt_SetInt.size(distinctIds) === validatedWebSrcSettings.length) {
    validatedWebSrcSettings$1 = validatedWebSrcSettings;
  } else {
    var maxId = Belt_Option.getWithDefault(Belt_SetInt.maximum(distinctIds), 0);
    validatedWebSrcSettings$1 = validatedWebSrcSettings.map(function (src, i) {
          return {
                  id: String((maxId + i | 0) + 1 | 0),
                  alias: src.alias,
                  url: src.url,
                  trusted: src.trusted,
                  err: src.err
                };
        });
  }
  var maxId$1 = validatedWebSrcSettings$1.reduce((function (maxId, src) {
          var id = Belt_Option.getExn(Belt_Int.fromString(src.id));
          if (id <= maxId) {
            return maxId;
          } else {
            return id;
          }
        }), 0);
  var newNextId = maxId$1 < st.webSrcNextId ? st.webSrcNextId : maxId$1 + 1 | 0;
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.webSrcSettings = validatedWebSrcSettings$1;
  newrecord.webSrcNextId = newNextId;
  var defaultSettings = createDefaultSettings(undefined);
  return defaultSettings.webSrcSettings.reduce((function (state, $$default) {
                var alias = $$default.alias;
                var url = $$default.url;
                var state$1;
                if (Belt_Option.isSome(Caml_option.undefined_to_opt(state.webSrcSettings.find(function (ws) {
                                return ws.alias === alias;
                              })))) {
                  state$1 = state;
                } else {
                  var newId = String(state.webSrcNextId);
                  var state$2 = addWebSrcSetting(state);
                  var newrecord = Caml_obj.obj_dup(state$2);
                  newrecord.webSrcSettings = state$2.webSrcSettings.map(function (ws) {
                        if (ws.id === newId) {
                          return {
                                  id: ws.id,
                                  alias: alias,
                                  url: ws.url,
                                  trusted: ws.trusted,
                                  err: ws.err
                                };
                        } else {
                          return ws;
                        }
                      });
                  state$1 = newrecord;
                }
                var newrecord$1 = Caml_obj.obj_dup(state$1);
                newrecord$1.webSrcSettings = state$1.webSrcSettings.map(function (ws) {
                      if (ws.alias === alias) {
                        return {
                                id: ws.id,
                                alias: ws.alias,
                                url: url,
                                trusted: ws.trusted,
                                err: ws.err
                              };
                      } else {
                        return ws;
                      }
                    });
                var newrecord$2 = Caml_obj.obj_dup(newrecord$1);
                newrecord$2.webSrcSettings = newrecord$1.webSrcSettings.sort(function (s1, s2) {
                      var i1 = defaultAliases.includes(s1.alias) ? 0 : 1;
                      var i2 = defaultAliases.includes(s2.alias) ? 0 : 1;
                      return i1 - i2 | 0;
                    });
                return newrecord$2;
              }), newrecord);
}

function validateLongClickDelayMs(ms) {
  if (ms < longClickDelayMsMin) {
    return {
            TAG: /* Ok */0,
            _0: longClickDelayMsMin
          };
  } else if (3000 < ms) {
    return {
            TAG: /* Ok */0,
            _0: 3000
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: ms
          };
  }
}

function validateCombCntMax(combCntMax) {
  if (combCntMax < 1) {
    return {
            TAG: /* Ok */0,
            _0: 1
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: combCntMax
          };
  }
}

function validateAndCorrectLongClickSettings(st) {
  var newrecord = Caml_obj.obj_dup(st);
  var ms = Belt_Int.fromString(st.longClickDelayMsStr);
  var tmp;
  if (ms !== undefined) {
    var ms$1 = validateLongClickDelayMs(ms);
    tmp = ms$1.TAG === /* Ok */0 ? String(ms$1._0) : String(500);
  } else {
    tmp = String(500);
  }
  newrecord.longClickDelayMsStr = tmp;
  return newrecord;
}

function validateEditorHistoryMaxLength(length) {
  if (length < 0) {
    return {
            TAG: /* Ok */0,
            _0: 0
          };
  } else if (1000 < length) {
    return {
            TAG: /* Ok */0,
            _0: 1000
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: length
          };
  }
}

function validateAndCorrectEditorHistoryMaxLengthSetting(st) {
  var newrecord = Caml_obj.obj_dup(st);
  var length = Belt_Int.fromString(st.editorHistMaxLengthStr);
  var tmp;
  if (length !== undefined) {
    var length$1 = validateEditorHistoryMaxLength(length);
    tmp = length$1.TAG === /* Ok */0 ? String(length$1._0) : String(20);
  } else {
    tmp = String(20);
  }
  newrecord.editorHistMaxLengthStr = tmp;
  return newrecord;
}

function validateAndCorrectState(st) {
  var st$1 = validateAndCorrectParens(st);
  var st$2 = validateAndCorrectDiscAndDeprSettings(st$1);
  var st$3 = validateAndCorrectDefaultStmtType(st$2);
  var st$4 = validateAndCorrectTypeSettings(st$3);
  var st$5 = validateAndCorrectUnifMetavarPrefix(st$4);
  var st$6 = validateAndCorrectWebSrcSettings(st$5);
  var st$7 = validateAndCorrectLongClickSettings(st$6);
  var st$8 = validateAndCorrectDefaultStmtLabel(st$7);
  var st$9 = validateAndCorrectEditorHistoryMaxLengthSetting(st$8);
  var newrecord = Caml_obj.obj_dup(st$9);
  var combCntMax = Belt_Int.fromString(st$9.combCntMaxStr);
  var tmp;
  if (combCntMax !== undefined) {
    var combCntMax$1 = validateCombCntMax(combCntMax);
    tmp = combCntMax$1.TAG === /* Ok */0 ? String(combCntMax$1._0) : String(10000);
  } else {
    tmp = String(10000);
  }
  newrecord.combCntMaxStr = tmp;
  return newrecord;
}

function stateToSettings(st) {
  return {
          parens: st.parens,
          asrtsToSkip: st.asrtsToSkip,
          descrRegexToDisc: st.descrRegexToDisc,
          labelRegexToDisc: st.labelRegexToDisc,
          descrRegexToDepr: st.descrRegexToDepr,
          labelRegexToDepr: st.labelRegexToDepr,
          discColor: st.discColor,
          deprColor: st.deprColor,
          tranDeprColor: st.tranDeprColor,
          allowedFrms: st.allowedFrms,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          defaultStmtType: st.defaultStmtType,
          defaultStmtLabel: st.defaultStmtLabel,
          initStmtIsGoal: st.initStmtIsGoal,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          autoMergeStmts: st.autoMergeStmts,
          autoUnifyAll: st.autoUnifyAll,
          typeSettings: st.typeSettings.map(function (typSett) {
                return {
                        typ: typSett.typ,
                        color: typSett.color,
                        prefix: typSett.prefix
                      };
              }),
          unifMetavarPrefix: st.unifMetavarPrefix,
          sortDisjByType: st.sortDisjByType,
          webSrcSettings: st.webSrcSettings.map(function (s) {
                return {
                        alias: s.alias,
                        url: s.url,
                        trusted: s.trusted
                      };
              }),
          longClickEnabled: st.longClickEnabled,
          longClickDelayMs: Belt_Option.getWithDefault(Belt_Int.fromString(st.longClickDelayMsStr), 500),
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLength: Belt_Option.getWithDefault(Belt_Int.fromString(st.editorHistMaxLengthStr), 20),
          combCntMax: Belt_Option.getWithDefault(Belt_Int.fromString(st.combCntMaxStr), 10000),
          useDefaultTransforms: st.useDefaultTransforms,
          useCustomTransforms: st.useCustomTransforms,
          customTransforms: st.customTransforms
        };
}

function settingsToState(ls) {
  return validateAndCorrectState({
              parens: ls.parens,
              parensErr: undefined,
              asrtsToSkip: ls.asrtsToSkip,
              descrRegexToDisc: ls.descrRegexToDisc,
              descrRegexToDiscErr: undefined,
              labelRegexToDisc: ls.labelRegexToDisc,
              labelRegexToDiscErr: undefined,
              descrRegexToDepr: ls.descrRegexToDepr,
              descrRegexToDeprErr: undefined,
              labelRegexToDepr: ls.labelRegexToDepr,
              labelRegexToDeprErr: undefined,
              discColor: ls.discColor,
              deprColor: ls.deprColor,
              tranDeprColor: ls.tranDeprColor,
              allowedFrms: ls.allowedFrms,
              editStmtsByLeftClick: ls.editStmtsByLeftClick,
              initStmtIsGoal: ls.initStmtIsGoal,
              defaultStmtLabel: ls.defaultStmtLabel,
              defaultStmtType: ls.defaultStmtType,
              checkSyntax: ls.checkSyntax,
              stickGoalToBottom: ls.stickGoalToBottom,
              autoMergeStmts: ls.autoMergeStmts,
              autoUnifyAll: ls.autoUnifyAll,
              typeNextId: 0,
              typeSettings: ls.typeSettings.map(function (lts) {
                    return {
                            id: "0",
                            typ: lts.typ,
                            color: lts.color,
                            prefix: lts.prefix,
                            err: undefined
                          };
                  }),
              unifMetavarPrefix: ls.unifMetavarPrefix,
              sortDisjByType: ls.sortDisjByType,
              webSrcNextId: 0,
              webSrcSettings: ls.webSrcSettings.map(function (s) {
                    return {
                            id: "0",
                            alias: s.alias,
                            url: s.url,
                            trusted: s.trusted,
                            err: undefined
                          };
                  }),
              longClickEnabled: ls.longClickEnabled,
              longClickDelayMsStr: String(ls.longClickDelayMs),
              hideContextSelector: ls.hideContextSelector,
              showVisByDefault: ls.showVisByDefault,
              editorHistMaxLengthStr: String(ls.editorHistMaxLength),
              useDefaultTransforms: ls.useDefaultTransforms,
              useCustomTransforms: ls.useCustomTransforms,
              customTransforms: ls.customTransforms,
              combCntMaxStr: String(ls.combCntMax)
            });
}

var settingsLocStorKey = "settings";

function settingsSaveToLocStor(settings) {
  localStorage.setItem(settingsLocStorKey, Expln_utils_common.stringify(settings));
}

function readStateFromLocStor(param) {
  var defaultSettings = createDefaultSettings(undefined);
  var settingsLocStorStr = localStorage.getItem(settingsLocStorKey);
  if (settingsLocStorStr === null) {
    return defaultSettings;
  }
  var parseResult = Expln_utils_jsonParse.parseJson(settingsLocStorStr, (function (__x) {
          return Expln_utils_jsonParse.asObj(__x, (function (d) {
                        return {
                                parens: Expln_utils_jsonParse.str(d, "parens", undefined, (function (param) {
                                        return defaultSettings.parens;
                                      }), undefined),
                                parensErr: undefined,
                                asrtsToSkip: Expln_utils_jsonParse.arr(d, "asrtsToSkip", (function (__x) {
                                        return Expln_utils_jsonParse.asStr(__x, undefined, undefined, undefined);
                                      }), undefined, (function (param) {
                                        return defaultSettings.asrtsToSkip;
                                      }), undefined),
                                descrRegexToDisc: Expln_utils_jsonParse.str(d, "descrRegexToDisc", undefined, (function (param) {
                                        return defaultSettings.descrRegexToDisc;
                                      }), undefined),
                                descrRegexToDiscErr: undefined,
                                labelRegexToDisc: Expln_utils_jsonParse.str(d, "labelRegexToDisc", undefined, (function (param) {
                                        return defaultSettings.labelRegexToDisc;
                                      }), undefined),
                                labelRegexToDiscErr: undefined,
                                descrRegexToDepr: Expln_utils_jsonParse.str(d, "descrRegexToDepr", undefined, (function (param) {
                                        return defaultSettings.descrRegexToDepr;
                                      }), undefined),
                                descrRegexToDeprErr: undefined,
                                labelRegexToDepr: Expln_utils_jsonParse.str(d, "labelRegexToDepr", undefined, (function (param) {
                                        return defaultSettings.labelRegexToDepr;
                                      }), undefined),
                                labelRegexToDeprErr: undefined,
                                discColor: Expln_utils_jsonParse.str(d, "discColor", undefined, (function (param) {
                                        return defaultDiscColor;
                                      }), undefined),
                                deprColor: Expln_utils_jsonParse.str(d, "deprColor", undefined, (function (param) {
                                        return defaultDeprColor;
                                      }), undefined),
                                tranDeprColor: Expln_utils_jsonParse.str(d, "tranDeprColor", undefined, (function (param) {
                                        return defaultTranDeprColor;
                                      }), undefined),
                                allowedFrms: Expln_utils_jsonParse.obj(d, "allowedFrms", (function (d) {
                                        return {
                                                inSyntax: Expln_utils_jsonParse.obj(d, "inSyntax", (function (d) {
                                                        return {
                                                                useDisc: Expln_utils_jsonParse.bool(d, "useDisc", undefined, undefined, undefined),
                                                                useDepr: Expln_utils_jsonParse.bool(d, "useDepr", undefined, undefined, undefined),
                                                                useTranDepr: Expln_utils_jsonParse.bool(d, "useTranDepr", undefined, undefined, undefined)
                                                              };
                                                      }), undefined, undefined, undefined),
                                                inEssen: Expln_utils_jsonParse.obj(d, "inEssen", (function (d) {
                                                        return {
                                                                useDisc: Expln_utils_jsonParse.bool(d, "useDisc", undefined, undefined, undefined),
                                                                useDepr: Expln_utils_jsonParse.bool(d, "useDepr", undefined, undefined, undefined),
                                                                useTranDepr: Expln_utils_jsonParse.bool(d, "useTranDepr", undefined, undefined, undefined)
                                                              };
                                                      }), undefined, undefined, undefined)
                                              };
                                      }), undefined, (function (param) {
                                        return defaultSettings.allowedFrms;
                                      }), undefined),
                                editStmtsByLeftClick: Expln_utils_jsonParse.bool(d, "editStmtsByLeftClick", undefined, (function (param) {
                                        return defaultSettings.editStmtsByLeftClick;
                                      }), undefined),
                                initStmtIsGoal: Expln_utils_jsonParse.bool(d, "initStmtIsGoal", undefined, (function (param) {
                                        return defaultSettings.initStmtIsGoal;
                                      }), undefined),
                                defaultStmtLabel: Expln_utils_jsonParse.str(d, "defaultStmtLabel", (function (str) {
                                        return {
                                                TAG: /* Ok */0,
                                                _0: validateDefaultStmtLabel(str)
                                              };
                                      }), (function (param) {
                                        return defaultSettings.defaultStmtLabel;
                                      }), undefined),
                                defaultStmtType: Expln_utils_jsonParse.str(d, "defaultStmtType", undefined, (function (param) {
                                        return defaultSettings.defaultStmtType;
                                      }), undefined),
                                checkSyntax: Expln_utils_jsonParse.bool(d, "checkSyntax", undefined, (function (param) {
                                        return defaultSettings.checkSyntax;
                                      }), undefined),
                                stickGoalToBottom: Expln_utils_jsonParse.bool(d, "stickGoalToBottom", undefined, (function (param) {
                                        return defaultSettings.stickGoalToBottom;
                                      }), undefined),
                                autoMergeStmts: Expln_utils_jsonParse.bool(d, "autoMergeStmts", undefined, (function (param) {
                                        return defaultSettings.autoMergeStmts;
                                      }), undefined),
                                autoUnifyAll: Expln_utils_jsonParse.bool(d, "autoUnifyAll", undefined, (function (param) {
                                        return defaultSettings.autoUnifyAll;
                                      }), undefined),
                                typeNextId: 0,
                                typeSettings: Expln_utils_jsonParse.arr(d, "typeSettings", (function (__x) {
                                        return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                      return {
                                                              id: "0",
                                                              typ: Expln_utils_jsonParse.str(d, "typ", undefined, undefined, undefined),
                                                              color: Expln_utils_jsonParse.str(d, "color", undefined, undefined, undefined),
                                                              prefix: Expln_utils_jsonParse.str(d, "prefix", undefined, undefined, undefined),
                                                              err: undefined
                                                            };
                                                    }), undefined, undefined, undefined);
                                      }), undefined, (function (param) {
                                        return defaultSettings.typeSettings;
                                      }), undefined),
                                unifMetavarPrefix: Expln_utils_jsonParse.str(d, "unifMetavarPrefix", undefined, (function (param) {
                                        return defaultSettings.unifMetavarPrefix;
                                      }), undefined),
                                sortDisjByType: Expln_utils_jsonParse.str(d, "sortDisjByType", undefined, (function (param) {
                                        return defaultSettings.sortDisjByType;
                                      }), undefined),
                                webSrcNextId: 0,
                                webSrcSettings: Expln_utils_jsonParse.arr(d, "webSrcSettings", (function (__x) {
                                        return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                      return {
                                                              id: "0",
                                                              alias: Expln_utils_jsonParse.str(d, "alias", undefined, undefined, undefined),
                                                              url: Expln_utils_jsonParse.str(d, "url", undefined, undefined, undefined),
                                                              trusted: Expln_utils_jsonParse.bool(d, "trusted", undefined, undefined, undefined),
                                                              err: undefined
                                                            };
                                                    }), undefined, undefined, undefined);
                                      }), undefined, (function (param) {
                                        return defaultSettings.webSrcSettings;
                                      }), undefined),
                                longClickEnabled: Expln_utils_jsonParse.bool(d, "longClickEnabled", undefined, (function (param) {
                                        return defaultSettings.longClickEnabled;
                                      }), undefined),
                                longClickDelayMsStr: String(Expln_utils_jsonParse.$$int(d, "longClickDelayMs", validateLongClickDelayMs, (function (param) {
                                            return 500;
                                          }), undefined)),
                                hideContextSelector: Expln_utils_jsonParse.bool(d, "hideContextSelector", undefined, (function (param) {
                                        return defaultSettings.hideContextSelector;
                                      }), undefined),
                                showVisByDefault: Expln_utils_jsonParse.bool(d, "showVisByDefault", undefined, (function (param) {
                                        return defaultSettings.showVisByDefault;
                                      }), undefined),
                                editorHistMaxLengthStr: String(Expln_utils_jsonParse.$$int(d, "editorHistMaxLength", validateEditorHistoryMaxLength, (function (param) {
                                            return 20;
                                          }), undefined)),
                                useDefaultTransforms: Expln_utils_jsonParse.bool(d, "useDefaultTransforms", undefined, (function (param) {
                                        return defaultSettings.useDefaultTransforms;
                                      }), undefined),
                                useCustomTransforms: Expln_utils_jsonParse.bool(d, "useCustomTransforms", undefined, (function (param) {
                                        return defaultSettings.useCustomTransforms;
                                      }), undefined),
                                customTransforms: Expln_utils_jsonParse.str(d, "customTransforms", undefined, (function (param) {
                                        return defaultSettings.customTransforms;
                                      }), undefined),
                                combCntMaxStr: String(Expln_utils_jsonParse.$$int(d, "combCntMax", validateCombCntMax, (function (param) {
                                            return 10000;
                                          }), undefined))
                              };
                      }), undefined, undefined, undefined);
        }), undefined, (function (param) {
          return defaultSettings;
        }), undefined);
  if (parseResult.TAG === /* Ok */0) {
    return validateAndCorrectState(parseResult._0);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot read settings from the local storage: " + parseResult._0 + ""
        },
        Error: new Error()
      };
}

function settingsReadFromLocStor(param) {
  return stateToSettings(readStateFromLocStor(undefined));
}

function isValid(st) {
  if (Belt_Option.isNone(st.parensErr) && Belt_Option.isNone(st.descrRegexToDiscErr) && Belt_Option.isNone(st.labelRegexToDiscErr) && Belt_Option.isNone(st.descrRegexToDeprErr) && Belt_Option.isNone(st.labelRegexToDeprErr) && st.typeSettings.every(function (ts) {
          return Belt_Option.isNone(ts.err);
        })) {
    return st.webSrcSettings.every(function (s) {
                return Belt_Option.isNone(s.err);
              });
  } else {
    return false;
  }
}

function eqState(st1, st2) {
  if (st1.parens === st2.parens && st1.descrRegexToDisc === st2.descrRegexToDisc && st1.labelRegexToDisc === st2.labelRegexToDisc && st1.descrRegexToDepr === st2.descrRegexToDepr && st1.labelRegexToDepr === st2.labelRegexToDepr && st1.discColor === st2.discColor && st1.deprColor === st2.deprColor && Caml_obj.equal(st1.allowedFrms, st2.allowedFrms) && st1.tranDeprColor === st2.tranDeprColor && st1.editStmtsByLeftClick === st2.editStmtsByLeftClick && st1.initStmtIsGoal === st2.initStmtIsGoal && st1.defaultStmtLabel === st2.defaultStmtLabel && st1.defaultStmtType === st2.defaultStmtType && st1.unifMetavarPrefix === st2.unifMetavarPrefix && st1.sortDisjByType === st2.sortDisjByType && st1.checkSyntax === st2.checkSyntax && st1.stickGoalToBottom === st2.stickGoalToBottom && st1.autoMergeStmts === st2.autoMergeStmts && st1.autoUnifyAll === st2.autoUnifyAll && st1.typeSettings.length === st2.typeSettings.length && st1.typeSettings.every(function (ts1, i) {
          var ts2 = Caml_array.get(st2.typeSettings, i);
          if (ts1.typ === ts2.typ && ts1.color === ts2.color) {
            return ts1.prefix === ts2.prefix;
          } else {
            return false;
          }
        }) && st1.webSrcSettings.length === st2.webSrcSettings.length && st1.webSrcSettings.every(function (ts1, i) {
          var ts2 = Caml_array.get(st2.webSrcSettings, i);
          if (ts1.alias === ts2.alias && ts1.url === ts2.url) {
            return ts1.trusted === ts2.trusted;
          } else {
            return false;
          }
        }) && st1.longClickEnabled === st2.longClickEnabled && st1.longClickDelayMsStr === st2.longClickDelayMsStr && st1.hideContextSelector === st2.hideContextSelector && st1.showVisByDefault === st2.showVisByDefault && st1.editorHistMaxLengthStr === st2.editorHistMaxLengthStr && st1.useDefaultTransforms === st2.useDefaultTransforms && st1.useCustomTransforms === st2.useCustomTransforms && st1.customTransforms === st2.customTransforms) {
    return st1.combCntMaxStr === st2.combCntMaxStr;
  } else {
    return false;
  }
}

function updateParens(st, parens) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.parensErr = undefined;
  newrecord.parens = parens;
  return newrecord;
}

function setDescrRegexToDisc(st, descrRegexToDisc) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.descrRegexToDiscErr = undefined;
  newrecord.descrRegexToDisc = descrRegexToDisc;
  return newrecord;
}

function setDiscColor(st, color) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.discColor = color;
  return newrecord;
}

function setDeprColor(st, color) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.deprColor = color;
  return newrecord;
}

function setTranDeprColor(st, color) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.tranDeprColor = color;
  return newrecord;
}

function updateUseDiscInSyntax(st, useDiscInSyntax) {
  var newrecord = Caml_obj.obj_dup(st);
  var init = st.allowedFrms;
  var init$1 = st.allowedFrms.inSyntax;
  newrecord.allowedFrms = {
    inSyntax: {
      useDisc: useDiscInSyntax,
      useDepr: init$1.useDepr,
      useTranDepr: init$1.useTranDepr
    },
    inEssen: init.inEssen
  };
  return newrecord;
}

function updateUseDiscInEssen(st, useDiscInEssen) {
  var newrecord = Caml_obj.obj_dup(st);
  var init = st.allowedFrms;
  var init$1 = st.allowedFrms.inEssen;
  newrecord.allowedFrms = {
    inSyntax: init.inSyntax,
    inEssen: {
      useDisc: useDiscInEssen,
      useDepr: init$1.useDepr,
      useTranDepr: init$1.useTranDepr
    }
  };
  return newrecord;
}

function updateUseDeprInSyntax(st, useDeprInSyntax) {
  var newrecord = Caml_obj.obj_dup(st);
  var init = st.allowedFrms;
  var init$1 = st.allowedFrms.inSyntax;
  newrecord.allowedFrms = {
    inSyntax: {
      useDisc: init$1.useDisc,
      useDepr: useDeprInSyntax,
      useTranDepr: init$1.useTranDepr
    },
    inEssen: init.inEssen
  };
  return newrecord;
}

function updateUseDeprInEssen(st, useDeprInEssen) {
  var newrecord = Caml_obj.obj_dup(st);
  var init = st.allowedFrms;
  var init$1 = st.allowedFrms.inEssen;
  newrecord.allowedFrms = {
    inSyntax: init.inSyntax,
    inEssen: {
      useDisc: init$1.useDisc,
      useDepr: useDeprInEssen,
      useTranDepr: init$1.useTranDepr
    }
  };
  return newrecord;
}

function updateUseTranDeprInSyntax(st, useTranDeprInSyntax) {
  var newrecord = Caml_obj.obj_dup(st);
  var init = st.allowedFrms;
  var init$1 = st.allowedFrms.inSyntax;
  newrecord.allowedFrms = {
    inSyntax: {
      useDisc: init$1.useDisc,
      useDepr: init$1.useDepr,
      useTranDepr: useTranDeprInSyntax
    },
    inEssen: init.inEssen
  };
  return newrecord;
}

function updateUseTranDeprInEssen(st, useTranDeprInEssen) {
  var newrecord = Caml_obj.obj_dup(st);
  var init = st.allowedFrms;
  var init$1 = st.allowedFrms.inEssen;
  newrecord.allowedFrms = {
    inSyntax: init.inSyntax,
    inEssen: {
      useDisc: init$1.useDisc,
      useDepr: init$1.useDepr,
      useTranDepr: useTranDeprInEssen
    }
  };
  return newrecord;
}

function updateTypeSetting(st, id, update) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.typeSettings = st.typeSettings.map(function (ts) {
        if (ts.id === id) {
          return Curry._1(update, ts);
        } else {
          return ts;
        }
      });
  return newrecord;
}

function addTypeSetting(st) {
  var newId = String(st.typeNextId);
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.typeSettings = st.typeSettings.concat([{
          id: newId,
          typ: "",
          color: Caml_array.get(allColors, 0),
          prefix: "",
          err: undefined
        }]);
  newrecord.typeNextId = st.typeNextId + 1 | 0;
  return newrecord;
}

function updateWebSrcSetting(st, id, update) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.webSrcSettings = st.webSrcSettings.map(function (s) {
        if (s.id === id) {
          return Curry._1(update, s);
        } else {
          return s;
        }
      });
  return newrecord;
}

function MM_cmp_settings(props) {
  var onChange = props.onChange;
  var preCtxData = props.preCtxData;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        return settingsToState(preCtxData.settingsV.val);
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return state;
      });
  var setPrevState = match$1[1];
  var prevState = match$1[0];
  React.useEffect((function () {
          var newState = settingsToState(preCtxData.settingsV.val);
          Curry._1(setState, (function (param) {
                  return newState;
                }));
          Curry._1(setPrevState, (function (param) {
                  return newState;
                }));
        }), [preCtxData.settingsV.ver]);
  var actParensChange = function (parens) {
    Curry._1(setState, (function (__x) {
            return updateParens(__x, parens);
          }));
  };
  var actDescrRegexToDiscUpdated = function (descrRegexToDisc) {
    Curry._1(setState, (function (__x) {
            return setDescrRegexToDisc(__x, descrRegexToDisc);
          }));
  };
  var actLabelRegexToDiscUpdated = function (labelRegexToDisc) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.labelRegexToDiscErr = undefined;
            newrecord.labelRegexToDisc = labelRegexToDisc;
            return newrecord;
          }));
  };
  var actDescrRegexToDeprUpdated = function (descrRegexToDepr) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.descrRegexToDeprErr = undefined;
            newrecord.descrRegexToDepr = descrRegexToDepr;
            return newrecord;
          }));
  };
  var actLabelRegexToDeprUpdated = function (labelRegexToDepr) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.labelRegexToDeprErr = undefined;
            newrecord.labelRegexToDepr = labelRegexToDepr;
            return newrecord;
          }));
  };
  var actDiscColorUpdated = function (color) {
    Curry._1(setState, (function (__x) {
            return setDiscColor(__x, color);
          }));
  };
  var actDeprColorUpdated = function (color) {
    Curry._1(setState, (function (__x) {
            return setDeprColor(__x, color);
          }));
  };
  var actTranDeprColorUpdated = function (color) {
    Curry._1(setState, (function (__x) {
            return setTranDeprColor(__x, color);
          }));
  };
  var actEditStmtsByLeftClickChange = function (editStmtsByLeftClick) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.editStmtsByLeftClick = editStmtsByLeftClick;
            return newrecord;
          }));
  };
  var actInitStmtIsGoalChange = function (initStmtIsGoal) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.initStmtIsGoal = initStmtIsGoal;
            return newrecord;
          }));
  };
  var actDefaultStmtLabelChange = function (defaultStmtLabel) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.defaultStmtLabel = defaultStmtLabel;
            return newrecord;
          }));
  };
  var actDefaultStmtTypeChange = function (defaultStmtType) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.defaultStmtType = defaultStmtType;
            return newrecord;
          }));
  };
  var actUnifMetavarPrefixChange = function (unifMetavarPrefix) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.unifMetavarPrefix = unifMetavarPrefix;
            return newrecord;
          }));
  };
  var actSortDisjByTypeChange = function (sortDisjByType) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.sortDisjByType = sortDisjByType;
            return newrecord;
          }));
  };
  var actLongClickDelayMsStrChange = function (longClickDelayMsStr) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.longClickDelayMsStr = longClickDelayMsStr;
            return newrecord;
          }));
  };
  var actCombCntMaxStrChange = function (str) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.combCntMaxStr = str;
            return newrecord;
          }));
  };
  var actEditorHistMaxLengthStrChange = function (editorHistMaxLengthStr) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.editorHistMaxLengthStr = editorHistMaxLengthStr;
            return newrecord;
          }));
  };
  var actCheckSyntaxChange = function (checkSyntax) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.checkSyntax = checkSyntax;
            return newrecord;
          }));
  };
  var actHideContextSelectorChange = function (hideContextSelector) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.hideContextSelector = hideContextSelector;
            return newrecord;
          }));
  };
  var actShowVisByDefaultChange = function (showVisByDefault) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.showVisByDefault = showVisByDefault;
            return newrecord;
          }));
  };
  var actStickGoalToBottomChange = function (stickGoalToBottom) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.stickGoalToBottom = stickGoalToBottom;
            return newrecord;
          }));
  };
  var actAutoMergeStmtsChange = function (autoMergeStmts) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.autoMergeStmts = autoMergeStmts;
            return newrecord;
          }));
  };
  var actAutoUnifyAllChange = function (autoUnifyAll) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.autoUnifyAll = autoUnifyAll;
            return newrecord;
          }));
  };
  var actLongClickEnabledChange = function (longClickEnabled) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.longClickEnabled = longClickEnabled;
            return newrecord;
          }));
  };
  var actTypeSettingAdd = function (param) {
    Curry._1(setState, addTypeSetting);
  };
  var actTypeSettingDelete = function (id) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.typeSettings = __x.typeSettings.filter(function (ts) {
                  return ts.id !== id;
                });
            return newrecord;
          }));
  };
  var actTypeChange = function (id, typ) {
    Curry._1(setState, (function (__x) {
            return updateTypeSetting(__x, id, (function (ts) {
                          return {
                                  id: ts.id,
                                  typ: typ,
                                  color: ts.color,
                                  prefix: ts.prefix,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actColorChange = function (id, color) {
    Curry._1(setState, (function (__x) {
            return updateTypeSetting(__x, id, (function (ts) {
                          return {
                                  id: ts.id,
                                  typ: ts.typ,
                                  color: color,
                                  prefix: ts.prefix,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actPrefixChange = function (id, prefix) {
    Curry._1(setState, (function (__x) {
            return updateTypeSetting(__x, id, (function (ts) {
                          return {
                                  id: ts.id,
                                  typ: ts.typ,
                                  color: ts.color,
                                  prefix: prefix,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actWebSrcSettingAdd = function (param) {
    Curry._1(setState, addWebSrcSetting);
  };
  var actWebSrcSettingDelete = function (id) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.webSrcSettings = __x.webSrcSettings.filter(function (s) {
                  return s.id !== id;
                });
            return newrecord;
          }));
  };
  var actAliasChange = function (id, alias) {
    Curry._1(setState, (function (__x) {
            return updateWebSrcSetting(__x, id, (function (s) {
                          return {
                                  id: s.id,
                                  alias: alias,
                                  url: s.url,
                                  trusted: s.trusted,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actUrlChange = function (id, url) {
    Curry._1(setState, (function (__x) {
            return updateWebSrcSetting(__x, id, (function (s) {
                          return {
                                  id: s.id,
                                  alias: s.alias,
                                  url: url,
                                  trusted: s.trusted,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actTrustedChange = function (id, trusted) {
    Curry._1(setState, (function (__x) {
            return updateWebSrcSetting(__x, id, (function (s) {
                          return {
                                  id: s.id,
                                  alias: s.alias,
                                  url: s.url,
                                  trusted: trusted,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actUseDiscInSyntaxChange = function (useDiscInSyntax) {
    Curry._1(setState, (function (__x) {
            return updateUseDiscInSyntax(__x, useDiscInSyntax);
          }));
  };
  var actUseDiscInEssenChange = function (useDiscInEssen) {
    Curry._1(setState, (function (__x) {
            return updateUseDiscInEssen(__x, useDiscInEssen);
          }));
  };
  var actUseDeprInSyntaxChange = function (useDeprInSyntax) {
    Curry._1(setState, (function (__x) {
            return updateUseDeprInSyntax(__x, useDeprInSyntax);
          }));
  };
  var actUseDeprInEssenChange = function (useDeprInEssen) {
    Curry._1(setState, (function (__x) {
            return updateUseDeprInEssen(__x, useDeprInEssen);
          }));
  };
  var actUseTranDeprInSyntaxChange = function (useTranDeprInSyntax) {
    Curry._1(setState, (function (__x) {
            return updateUseTranDeprInSyntax(__x, useTranDeprInSyntax);
          }));
  };
  var actUseTranDeprInEssenChange = function (useTranDeprInEssen) {
    Curry._1(setState, (function (__x) {
            return updateUseTranDeprInEssen(__x, useTranDeprInEssen);
          }));
  };
  var actUseDefaultTransformsChange = function (useDefaultTransforms) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.useDefaultTransforms = useDefaultTransforms;
            return newrecord;
          }));
  };
  var actUseCustomTransformsChange = function (useCustomTransforms) {
    Curry._1(setState, (function (__x) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.useCustomTransforms = useCustomTransforms;
            return newrecord;
          }));
  };
  var actRestoreDefaultTypeSettings = function (param) {
    Curry._1(setState, (function (state) {
            var defaultSettings = createDefaultSettings(undefined);
            return defaultSettings.typeSettings.reduce((function (state, $$default) {
                          var typ = $$default.typ;
                          var color = $$default.color;
                          var prefix = $$default.prefix;
                          var state$1;
                          if (Belt_Option.isSome(Caml_option.undefined_to_opt(state.typeSettings.find(function (ts) {
                                          return ts.typ === typ;
                                        })))) {
                            state$1 = state;
                          } else {
                            var newId = String(state.typeNextId);
                            var state$2 = addTypeSetting(state);
                            var newrecord = Caml_obj.obj_dup(state$2);
                            newrecord.typeSettings = state$2.typeSettings.map(function (ts) {
                                  if (ts.id === newId) {
                                    return {
                                            id: ts.id,
                                            typ: typ,
                                            color: ts.color,
                                            prefix: ts.prefix,
                                            err: ts.err
                                          };
                                  } else {
                                    return ts;
                                  }
                                });
                            state$1 = newrecord;
                          }
                          var newrecord$1 = Caml_obj.obj_dup(state$1);
                          newrecord$1.typeSettings = state$1.typeSettings.map(function (ts) {
                                if (ts.typ === typ) {
                                  return {
                                          id: ts.id,
                                          typ: ts.typ,
                                          color: color,
                                          prefix: prefix,
                                          err: ts.err
                                        };
                                } else {
                                  return ts;
                                }
                              });
                          return newrecord$1;
                        }), state);
          }));
  };
  var actRestoreDefaultDescrRegexToDisc = function (param) {
    var descrRegexToDisc = createDefaultSettings(undefined).descrRegexToDisc;
    Curry._1(setState, (function (__x) {
            return setDescrRegexToDisc(__x, descrRegexToDisc);
          }));
  };
  var actRestoreDefaultDiscUsageSettings = function (param) {
    var defaultSettings = createDefaultSettings(undefined);
    Curry._1(setState, (function (st) {
            return setTranDeprColor(setDeprColor(setDiscColor(updateUseTranDeprInEssen(updateUseDeprInEssen(updateUseDiscInEssen(updateUseTranDeprInSyntax(updateUseDeprInSyntax(updateUseDiscInSyntax(st, defaultSettings.allowedFrms.inSyntax.useDisc), defaultSettings.allowedFrms.inSyntax.useDepr), defaultSettings.allowedFrms.inSyntax.useTranDepr), defaultSettings.allowedFrms.inEssen.useDisc), defaultSettings.allowedFrms.inEssen.useDepr), defaultSettings.allowedFrms.inEssen.useTranDepr), defaultSettings.discColor), defaultSettings.deprColor), defaultSettings.tranDeprColor);
          }));
  };
  var makeActTerminate = function (modalId) {
    return Belt_Option.map(modalId, (function (modalId, param) {
                  MM_wrk_client.terminateWorker(undefined);
                  Expln_React_Modal.closeModal(modalRef, modalId);
                }));
  };
  var rndFindParensProgress = function (pct, modalIdOpt) {
    return MM_react_common.rndProgress("Searching parentheses", pct, makeActTerminate(modalIdOpt), undefined);
  };
  var actOpenCheckRegexDialog = function (initRegex, onSave) {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_test_regex.make, {
                                initRegex: initRegex,
                                onSave: (function (regex) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    Curry._1(onSave, regex);
                                  }),
                                onCancel: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var updatePreCtxDataForFragTransformEditor = function (preCtxData, useDefaultTransforms, useCustomTransforms) {
    var init = preCtxData.settingsV;
    var newrecord = Caml_obj.obj_dup(preCtxData.settingsV.val);
    return {
            settingsV: {
              ver: init.ver,
              val: (newrecord.useCustomTransforms = useCustomTransforms, newrecord.useDefaultTransforms = useDefaultTransforms, newrecord)
            },
            srcs: preCtxData.srcs,
            ctxV: preCtxData.ctxV,
            frms: preCtxData.frms,
            parenCnt: preCtxData.parenCnt,
            allTypes: preCtxData.allTypes,
            syntaxTypes: preCtxData.syntaxTypes
          };
  };
  var actOpenDefaultTransformsEditor = function (param) {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_frag_transform_editor.make, {
                                modalRef: modalRef,
                                preCtxData: updatePreCtxDataForFragTransformEditor(preCtxData, true, false),
                                readOnly: true,
                                title: "Default transforms script",
                                transformsText: MM_frag_transform_default_script.fragmentTransformsDefaultScript,
                                isCustom: false,
                                onCancel: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var actOpenCustomTransformsEditor = function (param) {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_frag_transform_editor.make, {
                                modalRef: modalRef,
                                preCtxData: updatePreCtxDataForFragTransformEditor(preCtxData, false, true),
                                readOnly: false,
                                title: "Custom transforms script",
                                transformsText: state.customTransforms,
                                isCustom: true,
                                onSave: (function (newText) {
                                    Curry._1(setState, (function (__x) {
                                            var newrecord = Caml_obj.obj_dup(__x);
                                            newrecord.customTransforms = newText;
                                            return newrecord;
                                          }));
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onCancel: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var rndParens = function (param) {
    var elems = [];
    elems.push(JsxPPXReactSupport.createElementVariadicWithKey("parens-text-field", Expln_React_Row.make, {
              alignItems: "center",
              children: Caml_option.some(null)
            }, [
              React.createElement(TextField, {
                    value: state.parens,
                    label: "Parentheses",
                    size: "small",
                    style: {
                      width: "400px"
                    },
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actParensChange, param);
                      }),
                    title: "Parentheses are used to speed up finding of substitutions",
                    error: Belt_Option.isSome(state.parensErr)
                  }),
              React.createElement("span", {
                    title: "Determine parentheses from the loaded MM file"
                  }, React.createElement(IconButton, {
                        onClick: (function (param) {
                            Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                        return rndFindParensProgress(0, undefined);
                                      })), (function (modalId) {
                                    Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                            return rndFindParensProgress(0, Caml_option.some(modalId));
                                          }));
                                    MM_wrk_FindParens.beginFindParens(preCtxData.ctxV.val, (function (pct) {
                                            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                    return rndFindParensProgress(pct, Caml_option.some(modalId));
                                                  }));
                                          }), (function (parens) {
                                            Curry._1(setState, (function (__x) {
                                                    return updateParens(__x, parens);
                                                  }));
                                            Expln_React_Modal.closeModal(modalRef, modalId);
                                          }));
                                  }));
                          }),
                        children: Caml_option.some(React.createElement(Sync, {}))
                      }))
            ]));
    var msg = state.parensErr;
    if (msg !== undefined) {
      elems.push(React.createElement("pre", {
                key: "parens-error",
                style: {
                  color: "red"
                }
              }, msg));
    }
    return elems;
  };
  var rndError = function (err) {
    if (err !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, err);
    } else {
      return null;
    }
  };
  var rndSingleCheckbox = function (checked, onChange) {
    return React.createElement(Checkbox, {
                checked: checked,
                onChange: (function (param) {
                    return Expln_React_common.evt2bool(onChange, param);
                  })
              });
  };
  var addAlignAttr = function (elem, alignValue) {
    return React.cloneElement(elem, {
                align: alignValue
              });
  };
  var rndDiscAsrtsSettings = function (param) {
    return React.createElement(Expln_React_Column.make, {
                spacing: 1.5,
                children: Caml_option.some(null)
              }, React.createElement(Expln_React_Row.make, {
                    alignItems: "center",
                    children: Caml_option.some(null)
                  }, React.createElement(TextField, {
                        value: state.descrRegexToDisc,
                        label: "Regex to determine discouraged assertions by description",
                        size: "small",
                        style: {
                          width: "500px"
                        },
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actDescrRegexToDiscUpdated, param);
                          }),
                        title: "All assertions with a description matching this regular expression will be marked as discouraged.",
                        error: Belt_Option.isSome(state.descrRegexToDiscErr)
                      }), MM_react_common.rndSmallTextBtn((function (param) {
                          actOpenCheckRegexDialog(state.descrRegexToDisc, actDescrRegexToDiscUpdated);
                        }), "Check regex"), MM_react_common.rndSmallTextBtn(actRestoreDefaultDescrRegexToDisc, "Restore default regex")), rndError(state.descrRegexToDiscErr), React.createElement(Expln_React_Row.make, {
                    alignItems: "center",
                    children: Caml_option.some(null)
                  }, React.createElement(TextField, {
                        value: state.labelRegexToDisc,
                        label: "Regex to determine discouraged assertions by label",
                        size: "small",
                        style: {
                          width: "500px"
                        },
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actLabelRegexToDiscUpdated, param);
                          }),
                        title: "All assertions with a label matching this regular expression will be marked as discouraged.",
                        error: Belt_Option.isSome(state.labelRegexToDiscErr)
                      }), MM_react_common.rndSmallTextBtn((function (param) {
                          actOpenCheckRegexDialog(state.labelRegexToDisc, actLabelRegexToDiscUpdated);
                        }), "Check regex")), rndError(state.labelRegexToDiscErr), React.createElement(Expln_React_Row.make, {
                    alignItems: "center",
                    children: Caml_option.some(null)
                  }, React.createElement(TextField, {
                        value: state.descrRegexToDepr,
                        label: "Regex to determine deprecated assertions by description",
                        size: "small",
                        style: {
                          width: "500px"
                        },
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actDescrRegexToDeprUpdated, param);
                          }),
                        title: "All assertions with a description matching this regular expression will be marked as deprecated.",
                        error: Belt_Option.isSome(state.descrRegexToDeprErr)
                      }), MM_react_common.rndSmallTextBtn((function (param) {
                          actOpenCheckRegexDialog(state.descrRegexToDepr, actDescrRegexToDeprUpdated);
                        }), "Check regex")), rndError(state.descrRegexToDeprErr), React.createElement(Expln_React_Row.make, {
                    alignItems: "center",
                    children: Caml_option.some(null)
                  }, React.createElement(TextField, {
                        value: state.labelRegexToDepr,
                        label: "Regex to determine deprecated assertions by label",
                        size: "small",
                        style: {
                          width: "500px"
                        },
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actLabelRegexToDeprUpdated, param);
                          }),
                        title: "All assertions with a label matching this regular expression will be marked as deprecated.",
                        error: Belt_Option.isSome(state.labelRegexToDeprErr)
                      }), MM_react_common.rndSmallTextBtn((function (param) {
                          actOpenCheckRegexDialog(state.labelRegexToDepr, actLabelRegexToDeprUpdated);
                        }), "Check regex")), rndError(state.labelRegexToDeprErr), React.createElement("table", {
                    style: {
                      border: "none",
                      borderCollapse: "collapse"
                    }
                  }, React.createElement("thead", undefined, React.createElement("tr", undefined, addAlignAttr(React.createElement("td", {
                                    className: "table-single-border",
                                    style: {
                                      border: "none"
                                    },
                                    colSpan: 2
                                  }, "Allowed usage"), "center"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border",
                                    colSpan: 2
                                  }, React.createElement("span", undefined, "Proofs")), "center"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border",
                                    rowSpan: 2
                                  }, React.createElement("span", undefined, "Color")), "center")), React.createElement("tr", undefined, addAlignAttr(React.createElement("td", {
                                    className: "table-single-border",
                                    style: {
                                      border: "none"
                                    },
                                    colSpan: 2
                                  }, "of assertions in proofs"), "center"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border",
                                    style: {
                                      minWidth: "70px"
                                    }
                                  }, React.createElement("span", undefined, "Syntax")), "center"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border",
                                    style: {
                                      minWidth: "70px"
                                    }
                                  }, React.createElement("span", undefined, "Essential")), "center")), React.createElement("tr", undefined, React.createElement("td", {
                                className: "table-single-border rotateM90",
                                rowSpan: 3
                              }, "Assertions"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border",
                                    style: {
                                      padding: "3px"
                                    }
                                  }, "Discouraged"), "right"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border"
                                  }, rndSingleCheckbox(state.allowedFrms.inSyntax.useDisc, actUseDiscInSyntaxChange)), "center"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border"
                                  }, rndSingleCheckbox(state.allowedFrms.inEssen.useDisc, actUseDiscInEssenChange)), "center"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border"
                                  }, MM_react_common.rndColorSelect(allColors, state.discColor, actDiscColorUpdated, undefined, undefined)), "center")), React.createElement("tr", undefined, addAlignAttr(React.createElement("td", {
                                    className: "table-single-border",
                                    style: {
                                      padding: "3px"
                                    }
                                  }, "Deprecated"), "right"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border"
                                  }, rndSingleCheckbox(state.allowedFrms.inSyntax.useDepr, actUseDeprInSyntaxChange)), "center"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border"
                                  }, rndSingleCheckbox(state.allowedFrms.inEssen.useDepr, actUseDeprInEssenChange)), "center"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border"
                                  }, MM_react_common.rndColorSelect(allColors, state.deprColor, actDeprColorUpdated, undefined, undefined)), "center")), React.createElement("tr", undefined, addAlignAttr(React.createElement("td", {
                                    className: "table-single-border",
                                    style: {
                                      padding: "3px"
                                    }
                                  }, "Transitively deprecated"), "right"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border"
                                  }, rndSingleCheckbox(state.allowedFrms.inSyntax.useTranDepr, actUseTranDeprInSyntaxChange)), "center"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border"
                                  }, rndSingleCheckbox(state.allowedFrms.inEssen.useTranDepr, actUseTranDeprInEssenChange)), "center"), addAlignAttr(React.createElement("td", {
                                    className: "table-single-border"
                                  }, MM_react_common.rndColorSelect(allColors, state.tranDeprColor, actTranDeprColorUpdated, undefined, undefined)), "center")))), MM_react_common.rndSmallTextBtn(actRestoreDefaultDiscUsageSettings, "Restore default assertion usage settings"));
  };
  var rndLongClickSettings = function (param) {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(FormControlLabel, {
                    control: React.createElement(Checkbox, {
                          checked: state.longClickEnabled,
                          onChange: (function (param) {
                              return Expln_React_common.evt2bool(actLongClickEnabledChange, param);
                            })
                        }),
                    label: "Enable long-click"
                  }), React.createElement(TextField, {
                    value: state.longClickDelayMsStr,
                    label: "Long click delay, ms",
                    size: "small",
                    style: {
                      width: "150px"
                    },
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actLongClickDelayMsStrChange, param);
                      }),
                    disabled: !state.longClickEnabled,
                    title: "How many milliseconds to wait for a click to become \"long\""
                  }));
  };
  var rndApplyChangesBtn = function (param) {
    var disabled = eqState(prevState, state);
    return React.createElement(Expln_React_Row.make, {
                spacing: 3,
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        var st = validateAndCorrectState(state);
                        Curry._1(setState, (function (param) {
                                return st;
                              }));
                        if (isValid(st)) {
                          Curry._1(setPrevState, (function (param) {
                                  return st;
                                }));
                          return Curry._1(onChange, stateToSettings(st));
                        }
                        
                      }),
                    variant: "contained",
                    disabled: disabled,
                    color: !isValid(state) ? "pastelred" : undefined,
                    children: "Apply changes"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(setState, (function (param) {
                                return prevState;
                              }));
                      }),
                    disabled: disabled,
                    children: "Discard changes"
                  }));
  };
  return React.createElement(Expln_React_Column.make, {
              spacing: 2,
              style: {
                margin: "30px"
              },
              children: Caml_option.some(null)
            }, rndApplyChangesBtn(undefined), React.createElement(Divider, {}), rndParens(undefined), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.checkSyntax,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actCheckSyntaxChange, param);
                          })
                      }),
                  label: "Check syntax"
                }), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.initStmtIsGoal,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actInitStmtIsGoalChange, param);
                          })
                      }),
                  label: "Mark the first provable step as a goal"
                }), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.stickGoalToBottom,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actStickGoalToBottomChange, param);
                          })
                      }),
                  label: "Stick the goal step to the bottom"
                }), React.createElement(TextField, {
                  value: state.defaultStmtLabel,
                  label: "Initial step label",
                  size: "small",
                  style: {
                    width: "200px"
                  },
                  onChange: (function (param) {
                      return Expln_React_common.evt2str(actDefaultStmtLabelChange, param);
                    }),
                  title: "This text is used as a label for the first provable step. If empty - a label will be generated automatically."
                }), React.createElement(TextField, {
                  value: state.defaultStmtType,
                  label: "Default statement type",
                  size: "small",
                  style: {
                    width: "200px"
                  },
                  onChange: (function (param) {
                      return Expln_React_common.evt2str(actDefaultStmtTypeChange, param);
                    }),
                  title: "This text is used as the initial statement type for new statements"
                }), React.createElement(MM_cmp_edit_stmts_setting.make, {
                  editStmtsByLeftClick: state.editStmtsByLeftClick,
                  longClickEnabled: state.longClickEnabled,
                  onChange: actEditStmtsByLeftClickChange
                }), rndLongClickSettings(undefined), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.hideContextSelector,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actHideContextSelectorChange, param);
                          })
                      }),
                  label: "Hide context header"
                }), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.showVisByDefault,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actShowVisByDefaultChange, param);
                          })
                      }),
                  label: "Show visualizations by default"
                }), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.autoMergeStmts,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actAutoMergeStmtsChange, param);
                          })
                      }),
                  label: "Automatically merge similar steps"
                }), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.autoUnifyAll,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actAutoUnifyAllChange, param);
                          })
                      }),
                  label: "Automatically \"Unify All\""
                }), React.createElement(Expln_React_Row.make, {
                  alignItems: "center",
                  spacing: 0,
                  children: Caml_option.some(null)
                }, React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            checked: state.useDefaultTransforms,
                            onChange: (function (param) {
                                return Expln_React_common.evt2bool(actUseDefaultTransformsChange, param);
                              })
                          }),
                      label: "Use default transforms"
                    }), MM_react_common.rndSmallTextBtn(actOpenDefaultTransformsEditor, "View default transforms")), React.createElement(Expln_React_Row.make, {
                  alignItems: "center",
                  spacing: 0,
                  children: Caml_option.some(null)
                }, React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            checked: state.useCustomTransforms,
                            onChange: (function (param) {
                                return Expln_React_common.evt2bool(actUseCustomTransformsChange, param);
                              })
                          }),
                      label: "Use custom transforms"
                    }), MM_react_common.rndSmallTextBtn(actOpenCustomTransformsEditor, "Edit custom transforms")), React.createElement(TextField, {
                  value: state.editorHistMaxLengthStr,
                  label: "Max length of editor history",
                  size: "small",
                  style: {
                    width: "200px"
                  },
                  onChange: (function (param) {
                      return Expln_React_common.evt2str(actEditorHistMaxLengthStrChange, param);
                    }),
                  title: "How many previous editor states to store."
                }), React.createElement(TextField, {
                  value: state.combCntMaxStr,
                  label: "Max number of combinations",
                  size: "small",
                  style: {
                    width: "200px"
                  },
                  onChange: (function (param) {
                      return Expln_React_common.evt2str(actCombCntMaxStrChange, param);
                    }),
                  title: "Max number of distinct combinations of arguments to check per assertion in \"Unify All\" and when proving bottom-up."
                }), React.createElement(Divider, {}), rndDiscAsrtsSettings(undefined), React.createElement(Divider, {}), React.createElement(TextField, {
                  value: state.unifMetavarPrefix,
                  label: "Prefix of metavariables in unification",
                  size: "small",
                  style: {
                    width: "310px"
                  },
                  onChange: (function (param) {
                      return Expln_React_common.evt2str(actUnifMetavarPrefixChange, param);
                    }),
                  title: "All variables with names starting with this prefix will be considered as metavariables during the unification process."
                }), React.createElement(TextField, {
                  value: state.sortDisjByType,
                  label: "Sort disjoint variables by type",
                  size: "small",
                  style: {
                    width: "310px"
                  },
                  onChange: (function (param) {
                      return Expln_React_common.evt2str(actSortDisjByTypeChange, param);
                    }),
                  title: "All variables in disjoint groups will be sorted by type according to this space separated list of types."
                }), React.createElement(MM_cmp_type_settings.make, {
                  typeSettings: state.typeSettings,
                  availableColors: allColors,
                  onAdd: actTypeSettingAdd,
                  onTypeChange: actTypeChange,
                  onColorChange: actColorChange,
                  onPrefixChange: actPrefixChange,
                  onDelete: actTypeSettingDelete,
                  onRestoreDefaults: actRestoreDefaultTypeSettings
                }), React.createElement(Divider, {}), React.createElement(MM_cmp_web_src_settings.make, {
                  webSrcSettings: state.webSrcSettings,
                  onAdd: actWebSrcSettingAdd,
                  onAliasChange: actAliasChange,
                  onUrlChange: actUrlChange,
                  onTrustedChange: actTrustedChange,
                  onDelete: actWebSrcSettingDelete,
                  defaultIds: defaultAliases.map(function (defaultAlias) {
                            return Caml_option.undefined_to_opt(state.webSrcSettings.find(function (webSrc) {
                                            return webSrc.alias === defaultAlias;
                                          }));
                          }).filter(Belt_Option.isSome).map(function (webSrcOpt) {
                        return Belt_Option.getExn(webSrcOpt).id;
                      })
                }), React.createElement(Divider, {}), rndApplyChangesBtn(undefined));
}

var make = MM_cmp_settings;

exports.settingsReadFromLocStor = settingsReadFromLocStor;
exports.settingsSaveToLocStor = settingsSaveToLocStor;
exports.make = make;
/* react Not a pure module */
